import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

//const API_ROOT2 = 'http://localhost/api'

export const getOverallBudgetReportReport = () => {
  const url = `${API_ROOT}/v1/accounting/overall-budget/page`
  return doGet(url)
}

export const searchOverallBudgetReportReport = (request) => {
  const url = `${API_ROOT}/v1/accounting/overall-budget/search`
  return doPost(url, request)
}

export const exportOverallBudgetReportReport = (request) => {
  const url = `${API_ROOT}/v1/accounting/overall-budget/export/excel`
  return doPostDownload(url, request)
}